import * as React from 'react';

import { useMessageContext } from '../../../../utils/messageContext';
import { BubbleMessageContainer } from '../../../BubbleMessageContainer';

export const BubblesContainer: React.FC = () => {
  const { message, messageId } = useMessageContext();

  const { bubbles } = message;

  if (!bubbles?.length) {
    return null;
  }

  return (
    <>
      {bubbles.map((bubble, index) => (
        <BubbleMessageContainer key={`${bubble.title.label}-${index}`} bubble={bubble} messageId={messageId} />
      ))}
    </>
  );
};
